import { RouteObject } from 'react-router-dom';
import FormElements from './pages/FormElements';

const formRoutes: RouteObject[] = [
  {
    path: 'elements',
    element: <FormElements />,
  },
];

export default formRoutes;
